import { IRootState } from '../../../store'

export const canViewFlagSelector = (state: IRootState): boolean =>
  state.user.privileges.some((p) => p === 'ViewFlag_S' || p === 'ViewFlag_C' || p === 'ViewFlag_R')

export const canAssignFlagSelector = (state: IRootState): boolean =>
  state.user.privileges.some((p) => p === 'RecFlagAssign_S' || p === 'RecFlagAssign_C' || p === 'RecFlagAssignOwn_S')
